import React from "react";
import { Volume2 } from "lucide-react";
import { useVoice, VOICE_LABELS } from "../context/VoiceContext";

/**
 * Compact Yoko/Kenzo toggle (pill) for the navbar.
 * Click cycles between the two native Japanese voices and persists the choice.
 * Available in 2 variants: "compact" (navbar) and "block" (page sections).
 */
export const VoiceSelector = ({ variant = "compact" }) => {
  const { voice, setVoice } = useVoice();

  if (variant === "block") {
    return (
      <div
        data-testid="voice-selector-block"
        className="inline-flex items-center gap-2 bg-white rounded-full border-2 border-[#1A2A40]/10 p-1 shadow-brut-sm"
      >
        {(["female", "male"]).map((v) => {
          const meta = VOICE_LABELS[v];
          const active = voice === v;
          return (
            <button
              key={v}
              data-testid={`voice-pick-${v}`}
              onClick={() => setVoice(v)}
              className={`px-3.5 py-1.5 rounded-full text-xs font-bold transition-all flex items-center gap-1.5 ${
                active
                  ? "bg-[#1A2A40] text-white shadow-sm"
                  : "text-[#4A5568] hover:text-[#1A2A40]"
              }`}
              aria-label={meta.desc}
              aria-pressed={active}
            >
              <span>{meta.emoji}</span> {meta.name}
            </button>
          );
        })}
      </div>
    );
  }

  // Compact: a single pill that cycles
  const meta = VOICE_LABELS[voice];
  const next = voice === "female" ? "male" : "female";
  return (
    <button
      data-testid="voice-selector-compact"
      onClick={() => setVoice(next)}
      title={`Voix actuelle : ${meta.desc}. Cliquer pour passer à ${VOICE_LABELS[next].name}.`}
      aria-label={`Voix japonaise : ${meta.name}. Cliquer pour basculer.`}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border border-[#1A2A40]/15 text-xs font-bold text-[#1A2A40] hover:border-[#E94A3F] hover:text-[#E94A3F] transition-colors"
    >
      <Volume2 className="w-3.5 h-3.5" />
      <span className="text-base leading-none">{meta.emoji}</span>
      <span>{meta.name}</span>
    </button>
  );
};

export default VoiceSelector;
